import { render, staticRenderFns } from "./reorganize.vue?vue&type=template&id=1aefb77a&scoped=true&"
import script from "./reorganize.vue?vue&type=script&lang=js&"
export * from "./reorganize.vue?vue&type=script&lang=js&"
import style0 from "./reorganize.vue?vue&type=style&index=0&id=1aefb77a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aefb77a",
  null
  
)

export default component.exports